import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	panel: {
		border: "1px solid #d1d5db",
		borderRadius: "4px",
		padding: "12px 14px",
		backgroundColor: "#fafafa",
	},
	heading: {
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: "13px",
		marginBottom: "6px",
		color: "#4b5563",
	},
	row: {
		fontSize: "13px",
		display: "flex",
		gap: "6px",
	},
	rowLabel: {
		fontWeight: 600,
	},
	hint: {
		fontSize: "12px",
		color: "#6b7280",
		marginTop: "8px",
	},
	empty: {
		fontStyle: "italic",
		color: "#6b7280",
		fontSize: "13px",
	},
}));

const CurrentFiltersPanel = ({ filters = [] }) => {
	const { classes } = useStyles();
	return (
		<div>
			<div className={classes.panel}>
				<Typography className={classes.heading}>
					Current page filters will be used
				</Typography>
				{filters.length === 0 ? (
					<span className={classes.empty}>No filters applied on this page.</span>
				) : (
					filters.map((f) => (
						<div key={f.label} className={classes.row}>
							<span className={classes.rowLabel}>{f.label}:</span>
							<span>{f.value}</span>
						</div>
					))
				)}
			</div>
			<Typography className={classes.hint}>
				The report will be generated using these filters each time.
			</Typography>
		</div>
	);
};

export default CurrentFiltersPanel;
